import { authFetch, requireAuthResponse } from '../../../auth'

export async function handleResponse(response) {
  const data = await response.json().catch(() => ({}))
  if (!response.ok) {
    const error = new Error(data.error || data.message || 'Error en la solicitud')
    error.payload = data
    throw error
  }
  return data
}

export function buildQuery(params = {}) {
  const query = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== '') {
          query.append(`${key}[]`, item)
        }
      })
      return
    }

    query.append(key, value)
  })

  const queryString = query.toString()
  return queryString ? `?${queryString}` : ''
}

export async function authJson(url, options) {
  return handleResponse(requireAuthResponse(await authFetch(url, options)))
}
